import React from "react";
import { Link } from "react-router-dom";
import downArrow from "../assets/downArrow.png";

const RefundPolicy = () => {
  return (
    <div className="bg-black text-white min-h-screen flex flex-col items-center px-8 py-10">
      {/* Back Button */}
      {/* <div className="absolute top-5 left-5">
        <Link to="/" className="text-white flex items-center space-x-2">
          <span className="text-2xl">&larr;</span>
          <span className="text-white">Back</span>
        </Link>
      </div> */}

      {/* Title */}
      <h1 className="text-primary text-4xl font-bold mb-2">Refund Policy</h1>
      <div className="flex justify-center">
        <img src={downArrow} alt="Arrow Down" className="h-7  mt-6 mb-6" />
      </div>
      {/* Content */}
      <div className="max-w-4xl space-y-6 text-left">
        {/* Conditions for Refunds */}
        <section>
          <h2 className="text-primary text-2xl font-semibold mb-2">Conditions for Refunds</h2>
          <p>Futcoinspot allows buyers to request refunds for products under reasonable conditions. We will issue refunds under the following conditions:</p>
          <ul className="list-disc list-inside space-y-2 mt-2">
            <li>Products not received: If the products were not fully delivered within the scheduled delivery time.</li>
            <li>Repeat payment: If buyers made repeated payments for one order, we will refund the additional payment(s), provided the order is not delivered.</li>
            <li>Payment amount mismatch: If your payment amount is less than the order amount, you can make up the balance; otherwise, your order will be cancelled and refunded within 7 days.</li>
            <li>Product mismatch: If the product received does not match the description.</li>
            <li>Nature of virtual goods: No shipping costs will be charged for refunds.</li>
          </ul>
        </section>

        {/* Conditions for No Refunds */}
        <section>
          <h2 className="text-primary text-2xl font-semibold mb-2">Conditions for No Refunds</h2>
          <p>Refunds will not be issued in the following cases:</p>
          <ul className="list-disc list-inside space-y-2 mt-2">
            <li>Completed delivery: Products delivered as agreed and confirmed by the buyer.</li>
            <li>Transactions made outside of Futcoinspot: No refunds for off-platform transactions.</li>
            <li>Buyer dissatisfaction: Refunds will not be granted due to buyer dissatisfaction, mistaken purchases, or failure to report issues within 72 hours.</li>
            <li>Fraudulent claims: Claims deemed fraudulent may lead to legal action and account suspension.</li>
            <li>Unpaid orders: No refunds will be issued for unpaid orders.</li>
          </ul>
        </section>

        {/* Confirmation of Receipt */}
        <section>
          <h2 className="text-primary text-2xl font-semibold mb-2">Confirmation of Receipt</h2>
          <p>
            Buyers must confirm receipt of the order only after verifying that the product is as described and in working condition. If no claims or issues are raised within 72 hours of delivery, the transaction is considered final, and no refunds will be provided.
          </p>
        </section>

        {/* Dispute Resolution */}
        <section>
          <h2 className="text-primary text-2xl font-semibold mb-2">Dispute Resolution</h2>
          <p>
            In case of a disagreement, buyers must provide relevant evidence (e.g., chat logs, order screenshots) to customer support within 72 hours. Failure to do so will result in forfeiture of the opportunity to resolve the dispute.
          </p>
        </section>

        {/* Order Cancellation Policy */}
        <section>
          <h2 className="text-primary text-2xl font-semibold mb-2">Order Cancellation Policy</h2>
          <p>
            Buyers can cancel orders by clicking the "Cancel Order" button. Futcoinspot will process cancellation requests according to the order status.
          </p>
        </section>

        {/* Return Policy */}
        <section>
          <h2 className="text-primary text-2xl font-semibold mb-2">Return Policy</h2>
          <p>
            Once a transaction is completed, returns are not allowed under any circumstances. Returning in-game items is prohibited, and buyers are solely responsible for their actions in such cases.
          </p>
        </section>

        {/* Non-Recurring Payment Policy */}
        <section>
          <h2 className="text-primary text-2xl font-semibold mb-2">Non-Recurring Payment Policy</h2>
          <p>
            Futcoinspot does not offer subscription-based services. All payments are for one-time purchases. Buyers must input all relevant information during each purchase to ensure accuracy.
          </p>
        </section>

        {/* About Refund Requests */}
        <section>
          <h2 className="text-primary text-2xl font-semibold mb-2">About Refund Requests</h2>
          <p>
            Buyers should contact our 24/7 customer service for assistance. Refund requests will be verified after submitting the order number and reason for the refund.
          </p>
        </section>

        {/* Refund Processing Time */}
        <section>
          <h2 className="text-primary text-2xl font-semibold mb-2">Refund Processing Time</h2>
          <p>
            Refund requests will be processed within 5 working days, but the actual refund time may vary based on the processing speed of different banks.
          </p>
        </section>
      </div>
    </div>
  );
};

export default RefundPolicy;
